/* eslint-disable */
//Ajax-JSON函数
//强制为同步模式
import $fn from "./fn";
import { Toast, Dialog } from "vant";
import { toSign } from "./HmacSHA";
import cookies from "./cookie";
import {
    getNormalizedUrl,
    isFileUploadRequest,
    buildRequestPath,
    getRequestBody,
    toSignV3,
} from "./toSignV3";
const TYPE = ["/collect/collect", "/v1/newLog"];
const blankUrls = [".txt"];
function isVersionGte(version, target) {
    const normalize = (v) =>
        String(v || "")
            .replace(/&.+/, "")
            .split(".")
            .map((item) => Number(item.replace(/[^0-9]/g, "") || 0));
    const a = normalize(version);
    const b = normalize(target);
    const len = Math.max(a.length, b.length);
    for (let i = 0; i < len; i++) {
        const av = a[i] || 0;
        const bv = b[i] || 0;
        if (av > bv) return true;
        if (av < bv) return false;
    }
    return true;
}
function AjaxJson(url, method, args, fn, dataType) {
    var obj = null;
    var ajax = new AjaxObject();
    ajax.URL = url;
    ajax.dataType = dataType;
    ajax.Method = method;
    ajax.Async = true;
    ajax.Args = args;
    ajax.onSuccess = function (xhr) {
        var text = xhr.responseText;
        if (text.charCodeAt() == 65279) text = text.substring(1); //处理utf8引导字节
        eval("obj=" + text);
        fn(obj, xhr);
        // console.log(obj);
        if (obj.code == 50008) {
            Toast(obj.msg);
            $fn.cookies.removeToken();
        } else if (obj.code == 50002) {
            Toast(obj.msg);
            $fn.cookies.removeToken();
        } else if (obj.code == 400 || obj.code == 401) {
            Dialog.alert({
                title: "登录提醒",
                message: `请先登录后操作`,
                theme: "round-button",
            }).then(() => {
                // on close
                // window.App.$router.push("/login");
            });
        } else if (obj.code != 200) {
            Toast(obj.msg);
        }
    };
    ajax.onFailure = function (xhr) {
        eval("obj={Tag:'ERROR',Status:'" + xhr.status + "'}");
        fn(obj);
    };
    ajax.Connect();
    return obj;
}

//Ajax标准类模块
function AjaxObject() {
    let mb = window.mb;
    let appv = $fn.cookies.getVersion();
    mb = mb ? mb : "ios";
    appv = appv ? appv : "2.9.0";
    let signParams = {
        appv: appv,
        device: mb,
        deviceId: cookies.getDeviceId() ? cookies.getDeviceId() : '',
    };
    if ($fn.getNewSign()) {
        signParams = {
            ...signParams,
            isEmbedded: true,
            embedded: 'web',
        }
    }
    const isVersion =
        Number(
            appv.replace(/&.+/, "").replace(/[^0-9]/g, "").slice(0, 3)
        ) >= 350 || window.mb === 'hos';
    const shouldSendXBoxAuthorization = isVersionGte(appv, "5.0.1");
    this.URL = "";
    this.Method = "GET";
    this.Async = true;
    this.Args = null;
    this.onSuccess = function () { };
    this.onFailure = function () { };
    this.Request = window.XMLHttpRequest
        ? new XMLHttpRequest()
        : new ActiveXObject("Microsoft.XMLHTTP");
    this.Connect = function () {
        const self = this;
        this.Method = this.Method.toUpperCase();
        const token = $fn.cookies.getToken("token");
        const requestPath = buildRequestPath(
            getNormalizedUrl(this.URL),
            null,
            this.Method,
        );
        const newSignObj = {
            method: this.Method || "",
            url:
                this.Method === "GET"
                    ? decodeURIComponent(requestPath || "")
                    : requestPath || "",
            deviceType: mb,
            deviceId: cookies.getDeviceId() ? cookies.getDeviceId() : "",
            appv: appv,
            token: token || "",
        };

        const connectAsync = async function () {
            const customHeaders = {};
            if (self.Method == "GET") {
                self.Args = self.Args ? self.Args : {};
                const shouldSignGet =
                    typeof self.Args == "object" &&
                    self.URL.indexOf("/ChannelDownLink/getBoxIosDownurl") === -1;
                var args = "";
                if (typeof self.Args == "object" && self.Args) {
                    // 增加sign验签参数
                    self.Args = $fn.toSign(
                        self.Args,
                        isVersion ? signParams : undefined,
                    );
                    var arr = new Array();
                    for (var k in self.Args) {
                        var v = self.Args[k];
                        arr.push(k + "=" + v);
                    }
                    args = arr.join("&");
                    self.URL += (self.URL.indexOf("?") == -1 ? "?" : "&") + args;
                    self.Args = null;
                    newSignObj.url +=
                        (requestPath.indexOf("?") == -1 ? "?" : "&") + args;
                }
                const isBlank = blankUrls.some(
                    (url) => self.URL && self.URL.includes(url),
                );
                if (shouldSendXBoxAuthorization && shouldSignGet && !isBlank) {
                    customHeaders["X-BOX-AUTHORIZATION"] = await toSignV3(
                        {},
                        newSignObj,
                    );
                }
            }
            var q = self.Request;
            var evt1 = self.onSuccess;
            var evt2 = self.onFailure;
            var evt3 = self.onLoadend;
            self.Request.onreadystatechange = function () {
                _onStateChange(q, evt1, evt2, evt3);
            };

            self.Request.open(self.Method, self.URL, self.Async);
            if (self.URL.indexOf("/cdnapp") < 0) {
                self.Request.setRequestHeader(
                    "deviceId",
                    cookies.getDeviceId() ? cookies.getDeviceId() : "",
                );
                self.Request.setRequestHeader(
                    "device",
                    mb,
                );
                self.Request.setRequestHeader(
                    "appv",
                    appv,
                );
                self.Request.setRequestHeader(
                    "box-agent",
                    $fn.headerBoxAgent(signParams),
                );
                // 分享页中 bypassword 接口不添加token
                if (self.URL.indexOf("v2/Login/bypassword") == -1) {
                    self.Request.setRequestHeader(
                        "token",
                        token,
                    );
                }
            }
            if (
                self.Method == "POST" ||
                self.Method == "PUT" ||
                self.Method == "DELETE"
            ) {
                if (self.dataType == "json") {
                    self.Request.setRequestHeader(
                        "Accept",
                        "application/json, text/plain, */*",
                    );
                    self.Request.setRequestHeader(
                        "Content-Type",
                        "application/json;charset=UTF-8",
                    );
                } else {
                    self.Request.setRequestHeader(
                        "Content-type",
                        "application/x-www-form-urlencoded;",
                    );
                }
                let args = "";
                // 与 GET 一致：未传 body 时 Args 为 null/undefined（见 originPost 只传 obj.data）
                if (typeof self.Args !== "string") {
                    self.Args = self.Args ? self.Args : {};
                }
                // 增加sign验签参数
                const typeSign = TYPE.some((url) => self.URL.indexOf(url) !== -1);
                if (typeSign) {
                    self.Args = toSign(self.Args);
                } else {
                    self.Args = $fn.toSign(
                        self.Args,
                        isVersion ? signParams : undefined,
                    );
                }
                if (typeof self.Args == "string") {
                    args = self.Args;
                } else if (typeof self.Args == "object") {
                    if (self.dataType == "json") {
                        self.Args = JSON.stringify(self.Args);
                    } else {
                        let arr = new Array();
                        for (let k in self.Args) {
                            let v = self.Args[k];
                            arr.push(k + "=" + v);
                        }
                        args = arr.join("&");
                        self.Args = encodeURI(args);
                    }
                }
                if (shouldSendXBoxAuthorization && self.Method === "POST") {
                    const isFileUpload = isFileUploadRequest({
                        method: self.Method,
                        data: self.Args,
                        headers: {
                            "Content-Type":
                                self.dataType == "json"
                                    ? "application/json;charset=UTF-8"
                                    : "application/x-www-form-urlencoded;",
                        },
                    });
                    const requestBodyStr = getRequestBody(self.Args, isFileUpload);
                    customHeaders["X-BOX-AUTHORIZATION"] = await toSignV3(
                        requestBodyStr,
                        newSignObj,
                    );
                }
            }
            for (let key in customHeaders) {
                self.Request.setRequestHeader(key, customHeaders[key]);
            }

            try {
                self.Request.send(self.Args);
            } catch (e) {
                console.log(e, "connect exception.");
            }
        };
        connectAsync();
    };

    function _onStateChange(xhr, success, failure) {
        if (xhr.readyState == 4) {
            var s = xhr.status;
            if (s == 0) {
                console.log("connect to url failure.");
            } else if (s >= 200 && s < 400) {
                success(xhr);
            } else {
                failure(xhr);
            }
        }
    }
}
class http {
    constructor() { }

    originPost(obj, fn) {
        if (obj.json !== undefined) {
            AjaxJson(obj.url, "post", obj.json, fn, "json");
        } else {
            AjaxJson(obj.url, "post", obj.data, fn);
        }
    }
    originGet(obj, fn) {
        if (obj.json !== undefined) {
            AjaxJson(obj.url, "get", obj.json, fn, "json");
        } else {
            AjaxJson(obj.url, "get", obj.data, fn);
        }
    }
    wrongCodeTest() {
        // try {
        // 	if (data.code == 400) {
        // 	}
        // } catch (err) {
        // 	console.log(err)
        // }
    }
    httpPost(obj) {
        return new Promise((resolve) => {
            this.originPost(obj, (res) => {
                resolve(res);
            });
        });
    }
    httpGet(obj) {
        return new Promise((resolve) => {
            this.originGet(obj, (res) => {
                this.wrongCodeTest(res);
                resolve(res);
            });
        });
    }
    msgPost(obj) {
        return new Promise((resolve) => {
            this.originPost(obj, (res) => {
                this.wrongCodeTest(res);
                if (res.code == 200) {
                    resolve(res.data);
                } else {
                    // _Msg.error(res.msg)
                }
            });
        });
    }
    usualPost(obj) {
        return new Promise((resolve, reject) => {
            this.originPost(obj, (res) => {
                this.wrongCodeTest(res);
                if (res.code == 200) {
                    resolve(res.data);
                } else {
                    reject(res);
                }
            });
        });
    }
}

export default new http();